// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"36da4031","134":"8fc5c553","273":"a7e40172","354":"0c3800ce","416":"1c08ba51","555":"a6ea2693","614":"bac79505","742":"1f1d9a90","791":"9b947fbb","803":"a80beb79","818":"9df92c0e","854":"51a5b96c","900":"78669aee","921":"017b8316","928":"844bc121"}[chunkId] + ".chunk.js";
};